import namespace from './namespace';

export default {
    [namespace.mutations.SET_LOGGING_EVENTS] (state, responseData) {
        state[namespace.state.LOGGING_EVENTS] = responseData;
    },
    [namespace.mutations.DELETE_LOGGING_EVENT_BY_ID] (state, loggingEventId) {
        let loggingEvents = state[namespace.state.LOGGING_EVENTS];
        state[namespace.state.LOGGING_EVENTS] = loggingEvents.filter(item => item.Id !== loggingEventId);
    },
    [namespace.mutations.CLEAR_LOGGING_EVENTS] (state) {
        state[namespace.state.LOGGING_EVENTS] = [];
    },
    [namespace.mutations.WAIT_FOR_DELETE_RESPONSE] (state, loggingEventId) {
        state[namespace.state.IDS_ARRAY_OF_ROWS_WAITING_FOR_DELETE].push(loggingEventId);
    },
    [namespace.mutations.STOP_WAIT_FOR_DELETE_RESPONSE] (state, loggingEventId) {
        let idsArray = state[namespace.state.IDS_ARRAY_OF_ROWS_WAITING_FOR_DELETE];
        state[namespace.state.IDS_ARRAY_OF_ROWS_WAITING_FOR_DELETE] = idsArray.filter(item => item !== loggingEventId);
    },
    [namespace.mutations.SET_SMTP_CONFIGURATION_STATE] (state, configuration) {
        let exist = configuration.Id != 0;
        let enabled = configuration.IsEnabled;
        state[namespace.state.IS_SMTP_CONFIGURATION_ENABLED] = exist && enabled;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/loggingEvents/mutations.js